module.exports = __webpack_public_path__ + "img/010_iss.78d0fc03.jpg";